import CryptoJS from 'crypto-js';
import { btoa, atob } from '../../lib/helpers';
import { postApi } from '../../lib/fetcher';
import state from './state';
import mutations from './mutations';
import api from './constans';

const merchantManagement = {
  namespaced: true,
  state,
  mutations,
  actions: {
    async fetchUsers(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search }
    ) {
      ctx.commit('clearUsers');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sortValue = '';
      if (sortBy[0] != null) {
        sortValue = `${sortBy[0]} ${sort}`;
      } else {
        sortValue = `id ${sort}`;
      }
      const data = JSON.stringify({
        search,
        sort_by: sortValue,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = api.GET_LIST_MERCHANT;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code === 200) {
        ctx.commit('setTotalUsers', {
          payload: responseData,
        });
        ctx.commit('setUsers', { payload: responseData });
      }
    },

    async updateUser(ctx, { date, user, changePassword, index }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id: user.id.toString(),
        username: user.username,
        change_password: changePassword,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = api.UPDATE_MERCHANT_USER;

      const responseData = await postApi(ctx, urlApi, data);

      let resVal = false;
      if (responseData?.code === 200) {
        const updatedUser = responseData.data;
        ctx.commit('editUser', {
          payload: updatedUser,
          index,
        });
        resVal = true;
      }
      return resVal;
    },

    async viewMerchant(
      ctx,
      { id, date, page, itemsPerPage, sortBy, sortDesc, search }
    ) {
      ctx.commit('clearUsersMerchant');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sortValue = '';
      if (sortBy[0] != null) {
        sortValue = `${sortBy[0]} ${sort}`;
      } else {
        sortValue = `id ${sort}`;
      }
      const data = JSON.stringify({
        id,
        search,
        sort_by: sortValue,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = api.GET_DETAIL_MERCHANT;

      const responseData = await postApi(ctx, urlApi, data);

      let resVal = false;
      if (responseData?.code === 200) {
        ctx.commit('setTotalUsers', {
          payload: responseData,
        });
        ctx.commit('setDetailMerchant', {
          payload: responseData.data,
        });
        resVal = true;
      }
      return resVal;
    },

    async viewBiometricStatus(ctx, { id, date, page, itemsPerPage }) {
      ctx.commit('clearBioList');
      ctx.commit('setLoading', true);

      const data = JSON.stringify({
        id,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = api.BIOMETRIC_STATUS;

      const responseData = await postApi(ctx, urlApi, data);

      let resVal = false;
      if (responseData?.code === 200) {
        ctx.commit('setBioList', {
          payload: responseData,
        });
        ctx.commit('setTotalBio', {
          payload: responseData,
        });
        resVal = true;
      }
      return resVal;
    },

    async blockUser(ctx, { id, date }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id,
        version: btoa(
          CryptoJS.SHA256(
            id.toString() + date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = api.BLOCK_MERCHANT_USER;

      const responseData = await postApi(ctx, urlApi, data);

  
      if (responseData?.code === 200) {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: responseData?.data?.message || 'User Blocked Successfully !',
            icon: 'mdi-check',
            color: 'green',
          },
          { root: true }
        );
        return true;
      } 
      ctx.commit(
        'setSnackbar',
        {
          status: true,
          message:responseData?.data?.message  || 'Block User Failed !',
          icon: 'mdi-alert',
          color: 'red',
        },
        { root: true }
      );
      return false;
    },

    async unBlockUser(ctx, { id, date }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id,
        version: btoa(
          CryptoJS.SHA256(
            id.toString() + date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = api.UNBLOCK_MERCHANT_USER;

      const responseData = await postApi(ctx, urlApi, data);

  
      if (responseData?.code === 200) {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: responseData?.data?.message || 'User Unblocked Successfully',
            icon: 'mdi-check',
            color: 'green',
          },
          { root: true }
        );
        return true;
      } 
      ctx.commit(
        'setSnackbar',
        {
          status: true,
          message: responseData?.data?.message  || 'Unblock User Failed !',
          icon: 'mdi-alert',
          color: 'red',
        },
        { root: true }
      );
      return false;
    }
  },
};
export default merchantManagement;
